<template>
    <vuestic-modal ref="modalFaturasPorTipoStatus" :cancelClass="'none'" :okClass="'none'">
        <div slot="title">Relatório de Faturas agrupado por tipo e status</div>
        <div v-if="!btn_load">
            <div id="CheckedListBox"
                style="border-width:1px;border-style:Solid;height:100px;width:420px;overflow-y:scroll;padding:2px;">
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="checkboxtodas" v-model="checkAll" /><label
                        class="form-check-label" for="checkboxtodas">Todas as Autoescolas</label><br>
                </div>

                <div class="form-check" v-for="(autoescola, index) in cfcs" :key="autoescola.value">
                    <input class="form-check-input" type="checkbox" :id="'ae' + index" :value="autoescola.value"
                        v-model="selectedCfcs" /><label class="form-check-label" :for="'ae' + index">{{ autoescola.text
                        }}</label>
                </div>
            </div>

            <input type="month" v-model="input_mes" class="form-control" placeholder="ex: yyyy-mm">
            <button v-if="!btn_download" class="btn btn-block btn-lg btn-secondary"
                @click="loadData('pdf')">PDF</button>
            <button v-else class="btn btn-block btn-lg btn-secondary" disabled>PDF</button>
            <button v-if="!btn_download" class="btn btn-block btn-lg btn-secondary"
                @click="loadData('csv')">CSV</button>
            <button v-else class="btn btn-block btn-lg btn-secondary" disabled>CSV</button>
            <button v-if="!btn_download" class="btn btn-block btn-lg btn-secondary"
                @click="loadData('xlsx')">XLSX</button>
            <button v-else class="btn btn-block btn-lg btn-secondary" disabled>XLSX</button>
        </div>
        <div v-else class="col-md-12 d-flex justify-content-center">
            <div class="btn-toolbar d-inline-flex" role="toolbar" aria-label="Toolbar with button groups">
                <component :animation-duration="1000" :is="'SpringSpinner'" :color="'#4AE387'" :size="80"></component>
            </div>
        </div>
    </vuestic-modal>
</template>

<script>
import * as spinners from 'epic-spinners'
import urlApi from '../../../../router/urlApiV2'
import Card from '../../../cards/card.vue';

export default {
    name: 'relatorioAdmin',
    components: {
        ...spinners,
        Card,
    },

    data() {
        return {
            btn_load: false,
            btn_download: false,
            input_mes: '',
            cfcs: [],
            selectedCfcs: [],
        }
    },
    mounted() {
        this.getCfcs();
    },

    methods: {
        open() {
            this.$refs.modalFaturasPorTipoStatus.open()
        },
        getCfcs() {
            this.$http.get(urlApi + '/autoescola').then(response => {
                response.data.dados.map(autoescolas => {
                    if (autoescolas.nome_fantasia !== 'TESTE') {
                        this.cfcs.push({
                            value: autoescolas.tenant_schema,
                            text: autoescolas.nome_fantasia,
                        })
                    }
                })
            })
        },
        loadData(type) {
            let schemas = this.checkAll ? 'all' : this.selectedCfcs;
            this.btn_load = true;
            if (!this.checkAll && this.selectedCfcs.length == 0) {
                this.$toasted.show('Selecione no mínimo uma autoescola!', {
                    position: 'top-right',
                })
                this.btn_load = false;
                return
            }
            if (this.input_mes == '') {
                this.$toasted.show('Informe o mês desejado!', {
                    position: 'top-right',
                })
                this.btn_load = false;
                return
            }
            if (type == 'pdf') {
                let url = urlApi + '/faturamento/exportar/faturas/tipo/status'
                this.$http.get(url, { params: { periodo: this.input_mes, schemas } })
                    .then(this.callBackLoadDataPDF)
                    .catch(function (error) {
                        this.btn_load = false;
                        this.$toasted.show(error.data.mensagem, {
                            position: 'top-right',
                        })
                    })
            } else if (type == 'csv') {
                let url = urlApi + '/faturamento/exportar/faturas/tipo/status';
                this.$http.get(url, { params: { detalhado: true, periodo: this.input_mes, schemas } })
                    .then(this.callBackLoadDataCSV)
                    .catch(function (error) {
                        this.btn_load = false;
                        this.$toasted.show(error.data.mensagem, {
                            position: 'top-right',
                        })
                    })
            } else if (type == 'xlsx') {
                let anchor = document.createElement("a");
                document.body.appendChild(anchor);

                this.$http.get(urlApi + '/faturamento/exportar/faturas/tipo/status', { params: { detalhado: true, xlsx: true, periodo: this.input_mes, schemas }, responseType: 'blob' })
                    .then(response => response.blob())
                    .then(responseBlob => {
                        console.log(responseBlob)
                        let objectUrl = window.URL.createObjectURL(responseBlob);
                        anchor.href = objectUrl;
                        anchor.download = 'faturas-tipo-status.xlsx';
                        anchor.click();
                        window.URL.revokeObjectURL(objectUrl);
                        this.btn_load = false;
                    });
            }
        },
        callBackLoadDataPDF(response) {
            this.downloadPDF(response.body.dados)
            this.btn_load = false;
        },
        callBackLoadDataCSV(response) {
            this.downloadCSV(response.body.dados)
            this.btn_load = false;
        },
        downloadPDF(response) {
            let code64 = response
            var pdf = 'data:application/octet-stream;base64,' + code64
            var dlnk = document.getElementById('download')
            dlnk.download = 'alunos-faturas.pdf'
            dlnk.href = pdf
            dlnk.click()
        },
        downloadCSV(response) {
            var dlnk = document.getElementById('download');
            dlnk.download = "alunos-faturas.csv";
            dlnk.href = 'data:text/csv;charset=utf-8,' + response;
            dlnk.click();
        },
    },
    // watch: {
    // selectedCfcs(newValue, oldValue) {
    //     if(!newValue) {
    //         this.selectedCfcs = []
    //     } else {
    //         this.selectedCfcs = this.cfcs.map(element => {
    //             return element.value;
    //         });
    //     }
    // },
    computed: {
        checkAll: {
            get() {
                return this.selectedCfcs.length == this.cfcs.length;
            },
            set(value) {
                if (value) {
                    this.selectedCfcs = this.cfcs.map(element => {
                        return element.value;
                    });
                } else {
                    this.selectedCfcs = []
                }
            }
        }
    }

}
</script>
